// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"578":"582898b1","748":"43f8cc72","936":"1dd3a3f7"}[chunkId] + ".chunk.css";
};